import { render } from "./Scorm.vue?vue&type=template&id=19cbe302&scoped=true"
import script from "./Scorm.vue?vue&type=script&lang=js"
export * from "./Scorm.vue?vue&type=script&lang=js"

import "./Scorm.vue?vue&type=style&index=0&id=19cbe302&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cbe302"]])

export default __exports__